import { useState } from 'react';
import MobileMenu from './MobileMenu';
import '../styles/Navbar.css';

const NAV_LINKS = [
  { label: 'XDP Airdrop', href: 'https://app.doppler.finance/airdrop', badge: true },
  { label: 'Products', href: '#products' },
  { label: 'Institutions', href: '#institutions' },
  { label: 'About', href: '#about' },
  { label: 'Blog', href: 'https://blog.doppler.finance/' },
];

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <>
      <header className="navbar">
        <div className="navbar__inner">
          <a href="/" className="navbar__logo">
            <img src="/images/doppler.svg" alt="Doppler" className="navbar__logo-img" />
            <span className="navbar__logo-text">Doppler</span>
          </a>

          <nav className="navbar__links">
            {NAV_LINKS.map((link) => (
              <a
                key={link.label}
                href={link.href}
                target={link.href.startsWith('http') ? '_blank' : undefined}
                rel="noreferrer"
                className="navbar__link"
              >
                {link.label}
                {link.badge && <span className="navbar__badge" aria-hidden="true" />}
              </a>
            ))}
          </nav>

          <a
            href="https://app.doppler.finance/vaults"
            target="_blank"
            rel="noreferrer"
            className="navbar__cta"
          >
            Enter App <span className="navbar__cta-arrow">↗</span>
          </a>

          <button
            type="button"
            className="navbar__hamburger"
            aria-label="Open menu"
            onClick={() => setMenuOpen(true)}
          >
            <span />
            <span />
            <span />
          </button>
        </div>
      </header>

      <MobileMenu isOpen={menuOpen} onClose={() => setMenuOpen(false)} />
    </>
  );
}